// src/constant/menu-footer.js

export const menuItems = [
    {
        label: "Explore",
        icon: "mdi:search",
        route: "",
    },
    {
        label: "Transaction",
        icon: "material-symbols:order-approve-sharp",
        route: "dashboard/ongoing",
    },
    {
        label: "History",
        icon: "icon-park-outline:history-query",
        route: "dashboard/orderhistory",
    },
    {
        label: "Cart",
        icon: "mdi:cart",
        route: "cart",
        showBadge: true
    },
    {
        label: "Log in",
        icon: "mdi:account",
        route: "login",
        guestOnly: true, // Ditampilkan hanya jika user adalah guest
    },
    {
        label: "Profile",
        icon: "mdi:account-circle",
        route: "dashboard/profile",
        authOnly: true, // Ditampilkan hanya jika user sudah login
    },
];